import { useSocketClient } from '@talos/kyoko';
import { useEffect } from 'react';
import { useFeatureFlag } from '../hooks/useFeatureFlag';

/**
 * Syncs the ui.BlockSubscriptions feature flag value to the WebSocket client blocked subscriptions list.
 */
export function BlockedSubscriptionsSyncer() {
  const client = useSocketClient();
  const { blockedSubscriptions } = useFeatureFlag();

  useEffect(() => {
    if (client == null) {
      return;
    }

    client.setBlockedSubscriptions(new Set(blockedSubscriptions));
  }, [client, blockedSubscriptions]);

  return null;
}
